module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=GB - United Kingdom.25fe2e22.svg";